import HttpRequest from '../HttpRequest';
import ENDPOINTS from './constants';

export default class TestingApi extends HttpRequest {
  testRequest() {
    return this.call(ENDPOINTS.TEST_REQUEST);
  }
}

export { ENDPOINTS };